/* Native Shopify packs and cart. No app, pricing overrides, or fabricated discounts. */
(() => {
  'use strict';
  if (window.GlowRivals) return;
  const config = JSON.parse(document.getElementById('gr-config')?.textContent || '{}');
  const root = (config.root || '/').replace(/\/?$/, '/');
  let busy = false, returnFocus, scrollY = 0, pendingFocusId, scrollLocked = false;
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const galleries = new WeakMap();
  function initGallery(gallery) {
    if (galleries.has(gallery)) return;
    const track = $('[data-gr-gallery]', gallery), slides = $$('[data-gr-slide]', gallery);
    if (!track || !slides.length) return;
    let index = 0, timer;
    // Inert bookends make adjacent previews available at both ends of the rail.
    const bookends = [];
    if (slides.length > 1) {
      const clone = source => { const el = source.cloneNode(true); el.removeAttribute('data-gr-slide'); el.setAttribute('aria-hidden', 'true'); el.inert = true; el.dataset.grBookend = ''; el.querySelectorAll('[id]').forEach(node => node.removeAttribute('id')); return el; };
      bookends.push(clone(slides.at(-1)), clone(slides[0]));
      track.prepend(bookends[0]); track.append(bookends[1]);
    }
    const physical = el => el.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - (track.clientWidth - el.offsetWidth) / 2;
    const position = i => physical(slides[i]);
    function sync(next) {
      index = Math.max(0, Math.min(slides.length - 1, next));
      gallery.dataset.grIndex = String(index);
      $$('[data-gr-thumb]', gallery).forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
      const count = $('[data-gr-gallery-count]', gallery);
      if (count) count.textContent = `${index + 1} / ${slides.length}`;
      $$('[data-gr-gallery-step]', gallery).forEach(button => {
        button.disabled = slides.length < 2;
      });
      const thumb = $$('[data-gr-thumb]', gallery)[index], thumbs = $('.gr-thumbs', gallery);
      if (thumb && thumbs) {
        const delta = thumb.getBoundingClientRect().left - thumbs.getBoundingClientRect().left;
        if (delta < 0 || delta + thumb.offsetWidth > thumbs.clientWidth) thumbs.scrollLeft += delta - (thumbs.clientWidth - thumb.offsetWidth) / 2;
      }
    }
    function go(next, animate = true) {
      clearTimeout(timer);
      const edge = next < 0 ? bookends[0] : next >= slides.length ? bookends[1] : null;
      sync((next % slides.length + slides.length) % slides.length);
      track.scrollTo({left:edge && animate ? physical(edge) : position(index), behavior:animate && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'});
    }
    function settled() {
      clearTimeout(timer);
      let nearest = 0, distance = Infinity;
      slides.forEach((slide, i) => { const d = Math.abs(position(i) - track.scrollLeft); if (d < distance) { distance = d; nearest = i; } });
      for (const [i, edge] of bookends.entries()) {
        if (Math.abs(physical(edge) - track.scrollLeft) < distance) {
          sync(i === 0 ? slides.length - 1 : 0);
          track.scrollTo({left:position(index), behavior:'instant'});
          return;
        }
      }
      sync(nearest);
    }
    track.addEventListener('scroll', () => { clearTimeout(timer); timer = setTimeout(settled, 120); }, {passive:true});
    track.addEventListener('scrollend', settled);
    track.addEventListener('keydown', e => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
      e.preventDefault(); go(e.key === 'Home' ? 0 : e.key === 'End' ? slides.length - 1 : index + (e.key === 'ArrowRight' ? 1 : -1));
    });
    const observer = new ResizeObserver(() => go(index, false));
    observer.observe(track);
    galleries.set(gallery, {go, destroy:() => {observer.disconnect(); clearTimeout(timer); bookends.forEach(el => el.remove()); galleries.delete(gallery);}});
    go(0, false);
  }
  function initGalleries() { $$('[data-gr-carousel]').forEach(initGallery); }
  const dialog = () => $('#gr-cart');
  function announce(message) { const el = $('[data-gr-live]'); if (el) el.textContent = message; }
  function showError(el, message) { if (el) { el.textContent = message || config.error; el.hidden = false; } }
  async function api(path, body) {
    const response = await fetch(root + path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' }, ...(body ? { body: JSON.stringify(body) } : {}) });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : config.error);
    return data;
  }
  function openCart(source) {
    const d = dialog(); if (!d) { location.assign(root + 'cart'); return; }
    if (d.open) return;
    returnFocus = source || document.activeElement;
    scrollY = window.scrollY;
    scrollLocked = true;
    document.body.style.top = `-${scrollY}px`;
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    d.showModal(); $('[data-gr-close]', d)?.focus(); updateSticky();
  }
  function closeCart() { dialog()?.close(); unlockScroll(); }
  function unlockScroll() {
    if (!scrollLocked) return;
    scrollLocked = false;
    document.body.style.position = ''; document.body.style.top = ''; document.body.style.width = '';
    window.scrollTo(0, scrollY); updateSticky(); if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
  }
  function bindDialog() {
    const d = dialog(); if (!d || d.dataset.bound) return;
    d.dataset.bound = 'true'; d.addEventListener('close', unlockScroll);
    d.addEventListener('click', e => { if (e.target === d) { const r = d.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right) closeCart(); } });
  }
  function setBusy(value) {
    if (value && document.activeElement?.dataset.focusId) pendingFocusId = document.activeElement.dataset.focusId;
    busy = value; const d = dialog(); if (d) d.setAttribute('aria-busy', String(value));
    $$('[data-gr-change],[data-gr-upgrade],.gr-checkout').forEach(b => { b.disabled = value; });
    $$('[data-gr-form]').forEach(form => { const selected = $('input[name="id"]:checked', form); $('[data-gr-add]', form).disabled = value || !selected || selected.dataset.available !== 'true'; });
    updateSticky();
    if (!value && pendingFocusId) {
      if (d?.open) ($(`[data-focus-id="${CSS.escape(pendingFocusId)}"]`, d) || $('[data-gr-close]', d))?.focus({preventScroll:true});
      pendingFocusId = null;
    }
  }
  async function refreshCart() {
    const d = dialog(); if (!d) return;
    const sectionURL = new URL(root + 'cart', location.origin); sectionURL.searchParams.set('section_id', 'gr-cart');
    const response = await fetch(sectionURL, { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error(config.error);
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const shell = $('.gr-cart-shell', doc); if (!shell) throw new Error(config.error);
    const focusId = document.activeElement?.dataset.focusId;
    const currentScroll = $('[data-gr-cart-body]', d)?.scrollTop || 0;
    $('.gr-cart-shell', d).replaceWith(shell);
    const state = $('[data-gr-cart-state]', doc); if (state) { const count = JSON.parse(state.textContent).count; $$('[data-gr-count]').forEach(x => x.textContent = count); }
    if (d.open) { $('[data-gr-cart-body]', d).scrollTop = currentScroll; const focus = focusId && $(`[data-focus-id="${CSS.escape(focusId)}"]`, d); (focus || $('[data-gr-close]', d))?.focus({ preventScroll: true }); }
    if (busy) setBusy(true);
    document.dispatchEvent(new CustomEvent('glowrivals:cart-updated'));
  }
  async function syncAfterMutation() {
    try { await refreshCart(); }
    catch (_) {
      // Mutation may already be committed; never repeat it because the section render failed.
      location.assign(root + 'cart');
    }
  }
  function updatePack(form) {
    const selected = $('input[name="id"]:checked', form); if (!selected) return;
    $(' [data-gr-price]', form).textContent = selected.dataset.price;
    const bands = $('[data-gr-bands-title]', form);
    if (bands) bands.textContent = bands.dataset.template.replace('[count]', selected.dataset.count || '0');
    $('[data-gr-add]', form).disabled = busy || selected.dataset.available !== 'true';
    if (selected.dataset.available === 'true') $('[data-gr-add-label]', form).textContent = $('[data-gr-add]', form).dataset.label;
    const error = $('[data-gr-product-error]', form); if (error) error.hidden = true;
    const stickyError = $('[data-gr-sticky-error]', form.closest('[data-gr-product]')); if (stickyError) stickyError.hidden = true;
    updateSticky();
  }
  function updateSticky() {
    $$('[data-gr-product]').forEach(product => {
      const bar = $('[data-gr-sticky]', product), form = $('[data-gr-form]', product);
      if (!bar || !form) return;
      const main = $('[data-gr-add]', form), selected = $('input[name="id"]:checked', form);
      bar.hidden = !main || main.getBoundingClientRect().bottom >= 0 || !!dialog()?.open;
      $('[data-gr-sticky-pack]', bar).textContent = selected?.dataset.packLabel || '';
      $('[data-gr-sticky-price]', bar).textContent = selected?.dataset.price || '';
      $('[data-gr-sticky-add]', bar).disabled = busy || !selected || selected.dataset.available !== 'true';
    });
  }
  let stickyFrame;
  function scheduleSticky() { if (stickyFrame) return; stickyFrame = requestAnimationFrame(() => { stickyFrame = null; updateSticky(); }); }
  window.addEventListener('scroll', scheduleSticky, {passive:true});
  window.addEventListener('resize', scheduleSticky);
  async function addBundle(form, source) {
    if (busy) return; setBusy(true); const error = $('[data-gr-product-error]', form); error.hidden = true;
    const stickyError = $('[data-gr-sticky-error]', form.closest('[data-gr-product]')); if (stickyError) stickyError.hidden = true;
    try {
      const fd = new FormData(form); const id = Number(fd.get('id')); if (!id) throw new Error(config.error);
      const properties = {}; for (const [key, value] of fd) { const match = /^properties\[(.+)\]$/.exec(key); if (match) properties[match[1]] = value; }
      await api('cart/add.js', { items: [{ id, quantity: 1, properties }] });
      await syncAfterMutation(); openCart(source); announce(config.added);
    } catch (e) {
      showError(error, e.message); // Resolve uncertain network outcomes by inspecting the bag before a retry.
      if (source?.matches('[data-gr-sticky-add]')) showError(stickyError, e.message);
      try { await refreshCart(); } catch (_) { /* Keep the native full cart link available. */ }
    } finally { setBusy(false); }
  }
  async function changeQuantity(button) {
    if (busy) return; setBusy(true);
    try { await api('cart/change.js', { id: button.dataset.key, quantity: Number(button.dataset.grChange) }); await syncAfterMutation(); announce(config.updated); }
    catch (e) { try { await refreshCart(); } catch (_) {} showError($('[data-gr-cart-error]'), e.message); }
    finally { setBusy(false); }
  }
  const sameProperties = (a = {}, b = {}) => JSON.stringify(Object.entries(a || {}).sort()) === JSON.stringify(Object.entries(b || {}).sort());
  async function upgradePack(button) {
    if (busy) return; setBusy(true);
    let original, addedKey, baseline = 0, added = false;
    try {
      const before = await api('cart.js'); original = before.items.find(x => x.key === button.dataset.key);
      if (!original || original.selling_plan_allocation) throw new Error(config.error);
      const targetId = Number(button.dataset.variant);
      baseline = before.items.filter(x => x.variant_id === targetId && sameProperties(x.properties, original.properties) && !x.selling_plan_allocation).reduce((n, x) => n + x.quantity, 0);
      // Add first so an unavailable larger pack cannot delete the customer's existing set.
      const result = await api('cart/add.js', { items: [{ id: targetId, quantity: original.quantity, properties: original.properties || {} }] });
      addedKey = result.items?.[0]?.key; added = true;
      // Discounts can change line keys after adding a pack. Read the current key again.
      const afterAdd = await api('cart.js');
      const oldLine = afterAdd.items.find(x => x.variant_id === original.variant_id && sameProperties(x.properties, original.properties) && !x.selling_plan_allocation);
      if (oldLine) await api('cart/change.js', { id: oldLine.key, quantity: 0 });
      await syncAfterMutation(); announce(config.updated);
    } catch (e) {
      let message = e.message;
      // On a failed removal, restore the target pack's previous quantity, preserving other cart items.
      // Read first: a timed-out remove might have succeeded on Shopify.
      if (added && original) {
        try {
          const current = await api('cart.js');
          const oldStillThere = current.items.some(x => x.variant_id === original.variant_id && sameProperties(x.properties, original.properties));
          const target = current.items.find(x => (x.key === addedKey || x.variant_id === Number(button.dataset.variant)) && sameProperties(x.properties, original.properties));
          if (oldStillThere && target) await api('cart/change.js', { id: target.key, quantity: baseline });
          if (!oldStillThere) message = '';
        } catch (_) { location.assign(root + 'cart'); return; }
      }
      try { await refreshCart(); } catch (_) { location.assign(root + 'cart'); return; }
      if (message) showError($('[data-gr-cart-error]'), message);
    } finally { setBusy(false); }
  }
  document.addEventListener('submit', e => {
    const form = e.target.closest('[data-gr-form]'); if (!form) return;
    e.preventDefault(); addBundle(form, e.submitter);
  });
  document.addEventListener('change', e => { if (e.target.matches('[data-gr-form] input[name="id"]')) updatePack(e.target.form); });
  document.addEventListener('click', async e => {
    const tickerButton = e.target.closest('[data-gr-ticker-toggle]');
    if (tickerButton) {
      const ticker = tickerButton.closest('[data-gr-ticker]');
      const paused = ticker.dataset.paused !== 'true';
      ticker.dataset.paused = String(paused);
      tickerButton.setAttribute('aria-pressed', String(paused));
      tickerButton.setAttribute('aria-label', paused ? tickerButton.dataset.playLabel : tickerButton.dataset.pauseLabel);
      return;
    }
    const sticky = e.target.closest('[data-gr-sticky-add]');
    if (sticky) { const form = $('[data-gr-form]', sticky.closest('[data-gr-product]')); if (form?.reportValidity()) addBundle(form, sticky); return; }
    const open = e.target.closest('[data-gr-open]'); if (open) { e.preventDefault(); openCart(open); if (!busy) { try { await refreshCart(); } catch (_) { showError($('[data-gr-cart-error]'), config.error); } } return; }
    if (e.target.closest('[data-gr-close]')) { closeCart(); return; }
    const change = e.target.closest('[data-gr-change]'); if (change) { changeQuantity(change); return; }
    const upgrade = e.target.closest('[data-gr-upgrade]'); if (upgrade) { upgradePack(upgrade); return; }
    const thumb = e.target.closest('[data-gr-thumb]');
    if (thumb) { galleries.get(thumb.closest('[data-gr-carousel]'))?.go(Number(thumb.dataset.grThumb)); return; }
    const arrow = e.target.closest('[data-gr-gallery-step]');
    if (arrow) { const gallery = arrow.closest('[data-gr-carousel]'); galleries.get(gallery)?.go(Number(gallery.dataset.grIndex) + Number(arrow.dataset.grGalleryStep)); return; }
    const tab = e.target.closest('[data-gr-modes] [role="tab"]'); if (tab) selectMode(tab);
  });
  function selectMode(tab) { const scope = tab.closest('[data-gr-modes]'); $$('[role="tab"]', scope).forEach(x => { x.setAttribute('aria-selected', String(x === tab)); x.tabIndex = x === tab ? 0 : -1; }); $$('[role="tabpanel"]', scope).forEach(x => x.hidden = x.id !== tab.getAttribute('aria-controls')); }
  document.addEventListener('keydown', e => { const tab = e.target.closest('[data-gr-modes] [role="tab"]'); if (!tab) return; const tabs = $$('[role="tab"]', tab.closest('[data-gr-modes]')); let index = tabs.indexOf(tab); if (['ArrowRight','ArrowDown'].includes(e.key)) index = (index + 1) % tabs.length; else if (['ArrowLeft','ArrowUp'].includes(e.key)) index = (index - 1 + tabs.length) % tabs.length; else if (e.key === 'Home') index = 0; else if (e.key === 'End') index = tabs.length - 1; else return; e.preventDefault(); selectMode(tabs[index]); tabs[index].focus(); });
  document.addEventListener('shopify:section:load', () => { bindDialog(); initGalleries(); $$('[data-gr-form]').forEach(updatePack); });
  document.addEventListener('shopify:section:unload', e => { $$('[data-gr-carousel]', e.target).forEach(gallery => galleries.get(gallery)?.destroy()); });
  document.addEventListener('shopify:block:select', e => { const tab = $(`[data-gr-mode-block="${CSS.escape(e.detail.blockId)}"]`); if (tab) selectMode(tab); });
  document.addEventListener('shopify:section:select', e => { if (e.target.querySelector('#gr-cart')) openCart(); });
  window.addEventListener('pageshow', e => { if (e.persisted && !busy) refreshCart().catch(() => {}); });
  bindDialog(); initGalleries(); $$('[data-gr-form]').forEach(updatePack);
  window.GlowRivals = { openCart, refreshCart };
})();
